import { type ClickModifiers, isPlainLeftClick } from './utils';

// A second history.back() before the first lands would cancel it and go back one page further.
const REPEAT_TAP_MS = 1000;
let wentBackAt = 0;

// By path, so a capsule in either URL, or a product page reloaded since, still counts.
function cameFromShop(shopHref: string): boolean {
    if (window.history.length < 2 || !document.referrer) { return false; }
    const shop = new URL(shopHref, window.location.href);
    const referrer = new URL(document.referrer);
    return referrer.origin === shop.origin && referrer.pathname === shop.pathname;
}

// Going back through history shows the shop as the shopper left it, often straight from the
// back/forward cache, instead of loading it again. A product opened from anywhere else links there.
export function returnToShop(event: ClickModifiers & Pick<MouseEvent, 'preventDefault'>, shopHref: string): void {
    if (!isPlainLeftClick(event) || !cameFromShop(shopHref)) { return; }
    event.preventDefault();
    if (Date.now() - wentBackAt < REPEAT_TAP_MS) { return; }
    wentBackAt = Date.now();
    window.history.back();
}
